module.exports = __webpack_public_path__ + "img/25.c89068a1.png";